import { render, staticRenderFns } from "./KpiStaff.vue?vue&type=template&id=e03ac484&scoped=true"
import script from "./KpiStaff.vue?vue&type=script&lang=js"
export * from "./KpiStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03ac484",
  null
  
)

export default component.exports